/**
 * 회사정보 재사용 영역
 */
export const CompanyInfo = {
  NAME: 'toptoon',
  // NAME_INC: 'TOPCO INTERNATIONAL INC.',
  NAME_INC: 'TOPCO GLOBAL INC.',
  NAME_UPPER_CASE: 'TOPTOON',
  NAME_CAMALCASE: 'Toptoon',
  DOMAIN: 'global.toptoon.com',
  EMAIL_CS: 'cs_global@toptoon.com',
};
